import React from 'react';

import { Grid } from '@mui/material';

function Info({ label, value }) {
  return (
    <>
      <Grid size={12} style={{ fontWeight: '600', fontSize: 14 }}>
        {label}:
      </Grid>
      <Grid size={12} style={{ fontSize: 14, color: '#777' }}>
        {value}
      </Grid>
    </>
  );
}

export default Info;
